import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";

export function AuthShell({ children, title, subtitle, image, side = "Welcome to Scholarlio" }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* visual */}
      <div className="relative hidden lg:block bg-primary">
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-primary/70" />
        <div className="relative h-full flex flex-col justify-between p-12 text-primary-foreground">
          <Link to="/">
            <Brand className="[&_span]:text-white [&>div]:bg-white [&>div]:text-primary" />
          </Link>
          <div>
            <h2 className="font-display text-4xl font-bold leading-tight max-w-md">{side}</h2>
            <p className="mt-4 text-primary-foreground/80 max-w-sm">
              AI-powered examination management with secure enrollment, controlled results and
              enterprise analytics.
            </p>
          </div>
          <div className="text-xs uppercase tracking-[0.2em] text-primary-foreground/60">
            Enterprise Assessment Platform
          </div>
        </div>
      </div>

      {/* form */}
      <div className="flex flex-col">
        <div className="lg:hidden h-16 border-b border-border flex items-center px-6">
          <Link to="/"><Brand /></Link>
        </div>
        <div className="flex-1 flex items-center justify-center p-6 md:p-12">
          <div className="w-full max-w-md animate-fade-up">
            <h1 className="font-display text-3xl font-bold tracking-tight">{title}</h1>
            <p className="mt-2 text-muted-foreground">{subtitle}</p>
            <div className="mt-8">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
